/**
 * Helper function to remove an item from local storage.
 *
 * @param {string} key
 */
export function removeStorageItem(key) {
  localStorage.removeItem(key);
}

/**
 * Helper function to set an item to local storage.
 *
 * @param {string} key
 * @param {(string|Object)} value
 */
export function setStorageItem(key, value) {
  if (value instanceof Object) {
    value = JSON.stringify(value);
  }
  localStorage.setItem(key, value);
}

/**
 * Helper function to get an item from local storage.
 *
 * @param {string} key
 * @returns {(string|Object)}
 */
export function getStorageItem(key) {
  let result;
  try {
    result = JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return localStorage.getItem(key);
  }
  return result;
}

/**
 * Helper function to clear whole local storage.
 */
export function resetLocalStorage() {
  localStorage.clear();
}
